import { JwtAxios } from '@/packaging';

// 상품 리포트 전용 API 집합
// 백엔드 구현 시 아래 엔드포인트를 맞춰주면 됩니다.
// - Summary: 상단 카드/차트용 집계
// - List: 하단 그리드 데이터
// - Excel: 현재 조회 조건 기반 다운로드
export const productReportApi = {
  async getSummary(body) {
    // body: { tabType, startDate, endDate, marketGroupIds, marketIds, sources }
    const res = await JwtAxios.post('/ProductReport/GetSummary', body);
    return res;
  },
  async getList(body) {
    // body: { tabType, startDate, endDate, marketGroupIds, marketIds, sources, page, pageSize, sort }
    const res = await JwtAxios.post('/ProductReport/GetList', body);
    return res;
  },
  async downloadExcel(body) {
    // body는 getList와 동일, 백엔드는 Content-Disposition 헤더로 파일명 내려주세요.
    const res = await JwtAxios.excelMultiPartPost('/ProductReport/DownloadExcel', body);
    return res;
  },
  // 미연동 상품 조회
  async getUnlinkedProducts(body) {
    // body: { market, marketAccount, marketIdx }
    const res = await JwtAxios.post('/ProductReport/GetUnlinkedProducts', body);
    return res;
  },
  // 미연동 상품 판매중지
  async suspendUnlinkedProducts(body) {
    // body: { market, marketAccount, marketIdx, productIds, suspendType }
    const res = await JwtAxios.post('/ProductReport/SuspendUnlinkedProducts', body);
    return res;
  },
  // 마켓미등록 상품 조회 (MongoDB에는 있지만 마켓에 없는 상품)
  async getOrphanProducts(body) {
    // body: { market, marketAccount, marketIdx }
    const res = await JwtAxios.post('/ProductReport/GetOrphanProducts', body);
    return res;
  },
  // 마켓미등록 상품 처리 (업로드 이력 초기화 또는 상품 삭제)
  async processOrphanProducts(body) {
    // body: { market, marketAccount, marketIdx, productIds, processType: 'clearHistory' | 'delete' }
    const res = await JwtAxios.post('/ProductReport/ProcessOrphanProducts', body);
    return res;
  },
  async cleanOrphanUploadSummaries() {
    const res = await JwtAxios.post('/ProductReport/CleanOrphanUploadSummaries');
    return res;
  },

  // ───────── 배치 작업 (전체 범위 산정 → 배치 처리 → 진행률 폴링) ─────────
  // 미매칭/DB전용 상품 배치 조회 시작
  async startUnlinkedScanJob(body) {
    // body: { market, marketAccount, marketIdx, mode: 'unlinked' | 'orphan', batchSize }
    const res = await JwtAxios.post('/ProductReport/StartUnlinkedScanJob', body);
    return res;
  },
  // 업로드 데이터 정리 배치 작업 시작
  async startCleanUploadDataJob(body) {
    // body: { batchSize }
    const res = await JwtAxios.post('/ProductReport/StartCleanUploadDataJob', body || {});
    return res;
  },
  // 배치 작업 진행 상황 + 결과 범위 조회
  async getBatchJobProgress(body) {
    // body: { jobId, itemOffset, itemLimit }
    const res = await JwtAxios.post('/ProductReport/GetBatchJobProgress', body);
    return res;
  },
  // 배치 작업 중단
  async cancelBatchJob(body) {
    // body: { jobId }
    const res = await JwtAxios.post('/ProductReport/CancelBatchJob', body);
    return res;
  }
};

